import { render } from "./FormulaireRole.vue?vue&type=template&id=09f899f6&scoped=true"
import script from "./FormulaireRole.vue?vue&type=script&lang=js"
export * from "./FormulaireRole.vue?vue&type=script&lang=js"

import "./FormulaireRole.vue?vue&type=style&index=0&id=09f899f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f899f6"]])

export default __exports__